import { useI18n } from "@wojo/localization";
import { Card, RadioButtonGroup, Text } from "@wojo/ui";
import React from "react";
import {
    useAlternateYearContext,
    useTourPageContext,
} from "../../_client/context";
import styles from "./TourAlternateYears.module.scss";

export const TourAlternateYears: React.FC<
    React.PropsWithChildren<unknown>
> = () => {
    const { alternateYears, tourContent } = useTourPageContext();
    const { setAlternateYearState, tourUUID } = useAlternateYearContext() || {};
    const { productPage } = useI18n("productPage");

    if (!alternateYears || alternateYears.length === 0) {
        return null;
    }

    const items = alternateYears.map(({ yearLabel, tourId }) => ({
        label: yearLabel,
        value: tourId,
    }));
    return !!items.length ? (
        <Card className={styles.card}>
            <RadioButtonGroup
                title={
                    <Text
                        tag="h2"
                        style={{ paddingBottom: "var(--g-spacing-sm)" }}
                    >
                        {productPage.alternateYears.heading.l()}
                    </Text>
                }
                variant={"column"}
                name="alternate-years"
                items={items}
                radioButtonWrapperClassname={styles.column}
                checkedValue={tourUUID || tourContent.id}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.currentTarget.value) {
                        setAlternateYearState?.({
                            tourUUID: e.currentTarget.value,
                        });
                    }
                }}
                hideRequired
            />
        </Card>
    ) : null;
};
